import '@babel/polyfill';
import '@witkac/vue-images/dist/vue-images.css';

import Vue from 'vue';
import { ResourceConfig } from '@witkac/kartamiejska-resources';
import { dateFilter, address } from '@witkac/kartamiejska-shared';

import { apolloClient } from './apollo';
import loaderService from '@/services/loader.service';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store/store';

async function bootstrap() {
  // Vue.use(vueMoment as any);
  Vue.filter('date', dateFilter);
  Vue.filter('address', address);
  Vue.config.productionTip = false;
  ResourceConfig.setApollo(apolloClient);
  ResourceConfig.setLoader(loaderService);

  await store.dispatch('system/loadCardName');
}
export const eventBus = new Vue();

bootstrap().then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
});
